import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import authReducer from './authSlice';
import navigationReducer from './navigationSlice';
import uiReducer from './uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    navigation: navigationReducer,
    ui: uiReducer,
  },
});

export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
